const firebaseConfig = {
  apiKey: "AIzaSyC-I_Sb3h-69Lli5wqCC22T4TkM52i1Lrc",
  authDomain: "rpp-hospital-authentication.firebaseapp.com",
  projectId: "rpp-hospital-authentication",
  storageBucket: "rpp-hospital-authentication.appspot.com",
  messagingSenderId: "1068857820093",
  appId: "1:1068857820093:web:cfc6bdeb78426db78c08d4",
};
export default firebaseConfig;
